import { render, staticRenderFns } from "./PainelDadosAbertos.vue?vue&type=template&id=314bc4c7"
import script from "./PainelDadosAbertos.vue?vue&type=script&lang=js"
export * from "./PainelDadosAbertos.vue?vue&type=script&lang=js"
import style0 from "./PainelDadosAbertos.vue?vue&type=style&index=0&id=314bc4c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports